import { io, Socket } from 'socket.io-client';
import { useCallback, useRef } from 'react';

import { SOCKET_BASE_URL } from 'configs';
import { authStorage } from 'store/storage';
import { USER_LOGOUT } from 'utils/logoutListener';

import { useHandleNotification } from './notification';

const _socket: {
  current: Socket | null;
  tokenExists: boolean;
} = {
  current: null,
  tokenExists: false,
};

window.addEventListener(USER_LOGOUT, () => {
  if (_socket.current) {
    _socket.current.disconnect();
  }
});

export enum SocketUserRooms {
  notification = 'notification',
}

const useSockets = (): { connect: () => void } => {
  const handleNotification = useHandleNotification();
  const handleNotificationRef = useRef(handleNotification);
  handleNotificationRef.current = handleNotification;
  const connect = useCallback((): void => {
    const token = authStorage.get()?.accessToken;

    const tokenExists = !!token;
    if (!tokenExists) {
      _socket.current?.disconnect();
      _socket.current = null;
      return;
    }

    if (_socket.current) return;

    _socket.current =
      _socket.current ||
      io(SOCKET_BASE_URL, {
        transports: ['websocket'],
        query: {
          token,
          type: 'affiliate',
        },
      });

    _socket.current.on(SocketUserRooms.notification, handleNotificationRef.current);

    _socket.current.on('disconnect', () => {
      _socket.current = null;
      connect();
    });
    _socket.current.on('close', () => {
      _socket.current = null;
      connect();
    });
  }, []);

  return {
    connect,
  };
};

export default useSockets;
